export enum ApplicationPage {
    HELP,
    SETTINGS,
    QUEUES,
    USERS,
    ERROR,
    HOME,
    LOADING,
    LOGGING
}